module.exports = __webpack_public_path__ + "img/大魔王_礼物.477d5c09.png";